"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerDateTime = void 0;
const consts_1 = require("@opsbase/lib-time/consts");
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
function AnswerDateTime(props) {
    const { form, questionNodeId } = props;
    const questionNode = form.questions[questionNodeId];
    const answer = form.answers[questionNodeId];
    const rule = form.rules[questionNode.questionId];
    let fmt = rule.isDateRequired && rule.isTimeRequired
        ? 'DD MMM YYYY hh:mm A'
        : rule.isTimeRequired
            ? consts_1.SimpleTimeFormat
            : 'DD MMM YYYY';
    return (0, react_1.useMemo)(() => {
        if ((0, moment_timezone_1.default)(answer.value).isValid()) {
            const text = (0, moment_timezone_1.default)(answer.value).tz(moment_timezone_1.default.tz.guess()).format(fmt) +
                ' ' +
                (0, moment_timezone_1.default)().tz(moment_timezone_1.default.tz.guess()).format('z');
            return react_1.default.createElement(Text_1.default, null, text);
        }
        return react_1.default.createElement(Text_1.default, null, '-');
    }, [answer.value, fmt]);
}
exports.AnswerDateTime = AnswerDateTime;
exports.default = AnswerDateTime;
